var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchoolSvgrepocom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1823_52241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.5 30.3C51.5 30.8 51 31.3 50.5 31.3C50 31.3 49.5 30.8 49.5 30.3V19.5C49.5 18.9 50 18.5 50.5 18.5C51 18.5 51.5 18.9 51.5 19.5V30.3Z",
    fill: "#B2C1C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 46.5H78.5V78.5H22.5V46.5Z",
    fill: "#E5DEC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9995 38.3C78.4995 37.3 77.1995 36.5 75.9995 36.5H24.8995C23.7995 36.5 22.3995 37.3 21.8995 38.3L18.5995 44.7C18.0995 45.7 18.5995 46.5 19.6995 46.5H81.0995C82.1995 46.5 82.6995 45.7 82.1995 44.7L78.9995 38.3Z",
    fill: "#D33B23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5 63.5C33.5 64 33.1 64.5 32.5 64.5H26.5C25.9 64.5 25.5 64 25.5 63.5V59.5C25.5 59 25.9 58.5 26.5 58.5H32.5C33.1 58.5 33.5 59 33.5 59.5V63.5Z",
    fill: "#D6EEF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5 53.5C33.5 54 33.1 54.5 32.5 54.5H26.5C25.9 54.5 25.5 54 25.5 53.5V49.5C25.5 49 25.9 48.5 26.5 48.5H32.5C33.1 48.5 33.5 49 33.5 49.5V53.5Z",
    fill: "#D6EEF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 55H26.5C25.7 55 25 54.3 25 53.5V49.5C25 48.7 25.7 48 26.5 48H32.5C33.3 48 34 48.7 34 49.5V53.5C34 54.3 33.3 55 32.5 55ZM26.5 49C26.2 49 26 49.2 26 49.5V53.5C26 53.8 26.2 54 26.5 54H32.5C32.8 54 33 53.8 33 53.5V49.5C33 49.2 32.8 49 32.5 49H26.5Z",
    fill: "#DBB471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 48.5H30V54.5H29V48.5Z",
    fill: "#DBB471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 65.5H26.5C25.7 65.5 25 64.8 25 64V60C25 59.2 25.7 58.5 26.5 58.5H32.5C33.3 58.5 34 59.2 34 60V64C34 64.8 33.3 65.5 32.5 65.5ZM26.5 59.5C26.2 59.5 26 59.7 26 60V64C26 64.3 26.2 64.5 26.5 64.5H32.5C32.8 64.5 33 64.3 33 64V60C33 59.7 32.8 59.5 32.5 59.5H26.5Z",
    fill: "#DBB471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 59H30V65H29V59Z",
    fill: "#DBB471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5 73.5C33.5 74 33.1 74.5 32.5 74.5H26.5C25.9 74.5 25.5 74 25.5 73.5V69.5C25.5 69 25.9 68.5 26.5 68.5H32.5C33.1 68.5 33.5 69 33.5 69.5V73.5Z",
    fill: "#D6EEF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 75.5H26.5C25.7 75.5 25 74.8 25 74V70C25 69.2 25.7 68.5 26.5 68.5H32.5C33.3 68.5 34 69.2 34 70V74C34 74.8 33.3 75.5 32.5 75.5ZM26.5 69.5C26.2 69.5 26 69.7 26 70V74C26 74.3 26.2 74.5 26.5 74.5H32.5C32.8 74.5 33 74.3 33 74V70C33 69.7 32.8 69.5 32.5 69.5H26.5Z",
    fill: "#DBB471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 69H30V75H29V69Z",
    fill: "#DBB471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5 63.5C75.5 64 75 64.5 74.5 64.5H68.5C68 64.5 67.5 64 67.5 63.5V59.5C67.5 59 68 58.5 68.5 58.5H74.5C75 58.5 75.5 59 75.5 59.5V63.5Z",
    fill: "#D6EEF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5 53.5C75.5 54 75 54.5 74.5 54.5H68.5C68 54.5 67.5 54 67.5 53.5V49.5C67.5 49 68 48.5 68.5 48.5H74.5C75 48.5 75.5 49 75.5 49.5V53.5Z",
    fill: "#D6EEF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5 55H68.5C67.7 55 67 54.3 67 53.5V49.5C67 48.7 67.7 48 68.5 48H74.5C75.3 48 76 48.7 76 49.5V53.5C76 54.3 75.3 55 74.5 55ZM68.5 49C68.2 49 68 49.2 68 49.5V53.5C68 53.8 68.2 54 68.5 54H74.5C74.8 54 75 53.8 75 53.5V49.5C75 49.2 74.8 49 74.5 49H68.5Z",
    fill: "#DBB471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 48.5H72V54.5H71V48.5Z",
    fill: "#DBB471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5 65.5H68.5C67.7 65.5 67 64.8 67 64V60C67 59.2 67.7 58.5 68.5 58.5H74.5C75.3 58.5 76 59.2 76 60V64C76 64.8 75.3 65.5 74.5 65.5ZM68.5 59.5C68.2 59.5 68 59.7 68 60V64C68 64.3 68.2 64.5 68.5 64.5H74.5C74.8 64.5 75 64.3 75 64V60C75 59.7 74.8 59.5 74.5 59.5H68.5Z",
    fill: "#DBB471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 59H72V65H71V59Z",
    fill: "#DBB471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5 73.5C75.5 74 75 74.5 74.5 74.5H68.5C68 74.5 67.5 74 67.5 73.5V69.5C67.5 69 68 68.5 68.5 68.5H74.5C75 68.5 75.5 69 75.5 69.5V73.5Z",
    fill: "#D6EEF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5 75.5H68.5C67.7 75.5 67 74.8 67 74V70C67 69.2 67.7 68.5 68.5 68.5H74.5C75.3 68.5 76 69.2 76 70V74C76 74.8 75.3 75.5 74.5 75.5ZM68.5 69.5C68.2 69.5 68 69.7 68 70V74C68 74.3 68.2 74.5 68.5 74.5H74.5C74.8 74.5 75 74.3 75 74V70C75 69.7 74.8 69.5 74.5 69.5H68.5Z",
    fill: "#DBB471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 69H72V75H71V69Z",
    fill: "#DBB471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3003 30.1C50.9003 29.8 50.2003 29.8 49.7003 30.1L30.3003 45.9C29.9003 46.2 29.9003 46.5 30.5003 46.5H70.5003C71.0003 46.5 71.2003 46.2 70.7003 45.9L51.3003 30.1Z",
    fill: "#F15744"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6996 45.9L51.2996 33.1C50.8996 32.7 50.1996 32.7 49.7996 33.1L34.2996 45.9C33.7996 46.2 33.8996 46.5 34.4996 46.5H36.4996V78.5H64.4996V46.5H66.4996C66.9996 46.5 67.1996 46.2 66.6996 45.9Z",
    fill: "#F9F3D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5 63.5H58.5V78.5H42.5V63.5Z",
    fill: "#E5DEC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5 63.5H56.5V78.5H44.5V63.5Z",
    fill: "#42ADE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6996 56.5C38.9996 56.6 39.3996 56.7 39.7996 56.7C40.2996 56.7 40.4996 56.5 40.4996 56.3C40.4996 56.1 40.2996 55.9 39.7996 55.8C39.0996 55.6 38.5996 55.2 38.5996 54.7C38.5996 54 39.1996 53.5 40.2996 53.5C40.7996 53.5 41.1996 53.6 41.3996 53.7L41.1996 54.4C40.9996 54.3 40.6996 54.2 40.2996 54.2C39.8996 54.2 39.6996 54.4 39.6996 54.6C39.6996 54.8 39.8996 55 40.4996 55.1C41.2996 55.4 41.5996 55.7 41.5996 56.3C41.5996 56.9 40.9996 57.5 39.7996 57.5C39.2996 57.5 38.7996 57.4 38.5996 57.3L38.6996 56.5Z",
    fill: "#89664C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4 57.3C45.2 57.4 44.8 57.5 44.3 57.5C42.8 57.5 42 56.7 42 55.6C42 54.3 43.1 53.5 44.4 53.5C44.9 53.5 45.3 53.6 45.5 53.7L45.3 54.4C45.1 54.3 44.8 54.3 44.5 54.3C43.7 54.3 43.1 54.7 43.1 55.6C43.1 56.4 43.6 56.9 44.5 56.9C44.8 56.9 45.1 56.8 45.3 56.8L45.4 57.3Z",
    fill: "#89664C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 53.6001V55.1001H48.6V53.6001H49.6V57.5001H48.6V55.9001H47V57.5001H46V53.6001H47Z",
    fill: "#89664C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4998 55.5C54.4998 56.8 53.5998 57.5 52.3998 57.5C51.0998 57.5 50.2998 56.6 50.2998 55.5C50.2998 54.3 51.0998 53.5 52.3998 53.5C53.6998 53.5 54.4998 54.4 54.4998 55.5ZM51.2998 55.5C51.2998 56.3 51.6998 56.8 52.3998 56.8C53.0998 56.8 53.3998 56.2 53.3998 55.5C53.3998 54.8 52.9998 54.2 52.2998 54.2C51.6998 54.2 51.2998 54.8 51.2998 55.5Z",
    fill: "#89664C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0994 55.5C59.0994 56.8 58.1994 57.5 56.9994 57.5C55.6994 57.5 54.8994 56.6 54.8994 55.5C54.8994 54.3 55.6994 53.5 56.9994 53.5C58.3994 53.5 59.0994 54.4 59.0994 55.5ZM55.9994 55.5C55.9994 56.3 56.3994 56.8 57.0994 56.8C57.7994 56.8 58.0994 56.2 58.0994 55.5C58.0994 54.8 57.6994 54.2 56.9994 54.2C56.3994 54.2 55.9994 54.8 55.9994 55.5Z",
    fill: "#89664C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7998 53.6001H60.7998V56.7001H62.4998V57.4001H59.7998V53.6001Z",
    fill: "#89664C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5 51.5C54.366 51.5 57.5 48.366 57.5 44.5C57.5 40.634 54.366 37.5 50.5 37.5C46.634 37.5 43.5 40.634 43.5 44.5C43.5 48.366 46.634 51.5 50.5 51.5Z",
    fill: "#DBB471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5 49.5C53.2614 49.5 55.5 47.2614 55.5 44.5C55.5 41.7386 53.2614 39.5 50.5 39.5C47.7386 39.5 45.5 41.7386 45.5 44.5C45.5 47.2614 47.7386 49.5 50.5 49.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 63.5H51V78.5H50V63.5Z",
    fill: "#E5DEC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5 40.5C50 40.5 49.5 41 49.5 41.5V45.5C49.5 46 50 46.5 50.5 46.5C51 46.5 51.5 46 51.5 45.5V41.5C51.5 41 51 40.5 50.5 40.5Z",
    fill: "#B2C1C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5 44.5H48.5C48 44.5 47.5 45 47.5 45.5C47.5 46 48 46.5 48.5 46.5H50.5C51 46.5 51.5 46 51.5 45.5C51.5 45 51 44.5 50.5 44.5Z",
    fill: "#F15744"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5 20.5V27.9C55.5 31.1 59.5 21 63.5 24.2C59.5 18.5 55.5 26.1 51.5 20.5Z",
    fill: "#B4D7EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4 58.8C50.9 58.4 50 58.4 49.5 58.8C47.4 60.3 40.5 64.5 40.5 64.5V66.5H60.5V64.5C60.5 64.5 53.6 60.3 51.4 58.8Z",
    fill: "#F15744"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5 78.5H19.5C18.9 78.5 18.5 79 18.5 79.5V81.5C18.5 82 18.9 82.5 19.5 82.5H81.5C82 82.5 82.5 82 82.5 81.5V79.5C82.5 79 82 78.5 81.5 78.5Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 80.5H62.5V82.5H38.5V80.5Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5 78.5H60.5V80.5H40.5V78.5Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5996 72H48.9996V72.7H47.5996V72Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 72H53.4V72.7H52V72Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1823_52241"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(18.5 18.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolSvgrepocom1);
export default __webpack_public_path__ + "static/media/school_svgrepo.com_1.b5eb61dcb6bfd7c8814bb102399d18d4.svg";
export { ForwardRef as ReactComponent };